import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'app-rating',
  templateUrl: 'ratingcomponent.html',
	styleUrls: ['ratingcomponent.css'],
	
})
	///Borrowed from http://embed.plnkr.co/Qi6tEdIyaRoGgSj2z4M9/
export class RatingComponent implements OnInit {
	@Input() ReadOnly: boolean = false;

	@Input() rating: number;
	@Output() ratingChange: EventEmitter<number> = new EventEmitter<number>();

	@Input() itemId: number;
	@Output() ratingClick: EventEmitter<any> = new EventEmitter<any>();

	inputName: string;
	ngOnInit() {
		this.inputName = 'r' + this.itemId + '_rating' + Date.now().toString() + Math.ceil(Math.random() * 1000000).toString();
	}
	onClick(rating: number): void {
		if (!this.ReadOnly) {
			this.rating = rating;
			this.ratingChange.emit(rating);

			this.ratingClick.emit({
				itemId: this.itemId,
				rating: rating
			});
		}
	}
}
